import React from "react";
import Weather from "./components/Weather";
import './App.css';

function App() {
  return (
    <div className="content">
      <h1>App Clima Tempo</h1>
      <Weather />
    </div>
  );
}

export default App;
